// Port of webapp/src/components/workspace.tsx — sidebar + main frame.

import {ReactElement, ReactNode} from 'react'
import Sidebar from './sidebar/sidebar'

type Props = {
    activeBoardId: string
    activeViewId: string | undefined
    readOnly: boolean
    children: ReactNode
}

export default function Workspace(props: Props): ReactElement {
    const {activeBoardId, activeViewId, readOnly, children} = props

    return (
        <div className='Workspace flex h-full min-w-0 flex-1 overflow-hidden'>
            <Sidebar activeBoardId={activeBoardId} activeViewId={activeViewId} readOnly={readOnly}/>
            <div className='mainFrame flex min-w-0 flex-1 flex-col overflow-hidden bg-main-bg'>
                {children}
            </div>
        </div>
    )
}
